import {
  TicketCategory,
  TicketCategoryLabels,
  TicketEventType,
  TicketPriority,
  TicketPriorityLabels,
  TicketStatus,
  TicketStatusLabels
} from '@navio/nsdk';
import { NoddiIconName } from 'noddi-ui-common';
import { constObjectToOptions } from 'noddi-util';

import { BadgeVariant } from 'noddi-ui-web';

type StatusMeta = {
  label: string;
  badgeVariant: BadgeVariant;
  dotClass: string;
};

type PriorityMeta = {
  label: string;
  dotClass: string;
  textClass: string;
};

type EventMeta = {
  icon: NoddiIconName;
  iconColorClass: string;
};

export const TICKET_STATUS_META: Record<TicketStatus, StatusMeta> = {
  [TicketStatus.OPEN]: {
    label: TicketStatusLabels.OPEN,
    badgeVariant: 'info',
    dotClass: 'bg-blue-500'
  },
  [TicketStatus.SNOOZED]: {
    label: TicketStatusLabels.SNOOZED,
    badgeVariant: 'warning',
    dotClass: 'bg-warning'
  },
  [TicketStatus.RESOLVED]: {
    label: TicketStatusLabels.RESOLVED,
    badgeVariant: 'success',
    dotClass: 'bg-success'
  },
  [TicketStatus.ARCHIVED]: {
    label: TicketStatusLabels.ARCHIVED,
    badgeVariant: 'outline',
    dotClass: 'bg-grey'
  }
};

export const TICKET_PRIORITY_META: Record<TicketPriority, PriorityMeta> = {
  [TicketPriority.URGENT]: {
    label: TicketPriorityLabels.URGENT,
    dotClass: 'bg-danger',
    textClass: 'text-dangerDark'
  },
  [TicketPriority.HIGH]: {
    label: TicketPriorityLabels.HIGH,
    dotClass: 'bg-noddiOrange',
    textClass: 'text-noddiOrange'
  },
  [TicketPriority.NORMAL]: {
    label: TicketPriorityLabels.NORMAL,
    dotClass: 'bg-grey',
    textClass: 'text-grey'
  },
  [TicketPriority.LOW]: {
    label: TicketPriorityLabels.LOW,
    dotClass: 'bg-silverGray',
    textClass: 'text-muted-foreground'
  }
};

export const TICKET_EVENT_META: Record<TicketEventType, EventMeta> = {
  [TicketEventType.CREATED]: { icon: 'Plus', iconColorClass: 'text-noddiPurple' },
  [TicketEventType.UPDATED]: { icon: 'Edit', iconColorClass: 'text-grey' },
  [TicketEventType.ASSIGNED]: { icon: 'User', iconColorClass: 'text-noddiPurple' },
  [TicketEventType.REASSIGNED]: { icon: 'Users', iconColorClass: 'text-noddiPurple' },
  [TicketEventType.UNASSIGNED]: { icon: 'User', iconColorClass: 'text-grey' },
  [TicketEventType.COMMENTED]: { icon: 'MessageSquare', iconColorClass: 'text-noddiPurple' },
  [TicketEventType.SNOOZED]: { icon: 'Clock', iconColorClass: 'text-warningDark' },
  [TicketEventType.RESOLVED]: { icon: 'CircleCheck', iconColorClass: 'text-successDark' },
  [TicketEventType.REOPENED]: { icon: 'RotateCcw', iconColorClass: 'text-noddiPurple' },
  [TicketEventType.ARCHIVED]: { icon: 'Archive', iconColorClass: 'text-grey' },
  [TicketEventType.RESTORED]: { icon: 'Undo2', iconColorClass: 'text-noddiPurple' }
};

export const TICKET_PRIORITY_OPTIONS = constObjectToOptions(TicketPriority, TicketPriorityLabels);
export const TICKET_CATEGORY_OPTIONS = constObjectToOptions(TicketCategory, TicketCategoryLabels);

export const TICKET_CATEGORY_LABELS = TicketCategoryLabels;
export const TICKET_STATUS_LABELS = TicketStatusLabels;
